import React, { useState, useEffect } from 'react';
import styles from '../../styles/GeneracionCargosManualesStyles/GeneracionCargosManuales.module.css';
import paginationStyles from '../../styles/PreasignacionMateriasStyles/PreasignacionMaterias.module.css';

const PAGE_SIZE = 15;

function StudentResults({ students = [], onStudentSelect }) {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(students.length / PAGE_SIZE));

  // Reiniciar a la primera página cuando cambia el listado (búsqueda/filtros)
  useEffect(() => {
    setCurrentPage(1);
  }, [students]);

  // Ajustar la página actual si queda fuera de rango tras cambiar los datos
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const paginated = students.slice(startIndex, startIndex + PAGE_SIZE);

  return (
    <div className={styles.tableSection}>
      <div className={styles.tableHeader}>
        <div className={styles.tableIcon}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21" stroke="#ed8b00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h3 className={styles.tableTitle}>Estudiantes</h3>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Matrícula</th>
              <th>Campus</th>
              <th>Programa</th>
              <th>Ciclo Escolar</th>
            </tr>
          </thead>
          <tbody>
            {paginated && paginated.length > 0 ? (
              paginated.map((student, index) => (
                <tr
                  key={student.id || student.id_estudiante}
                  className={index % 2 === 0 ? styles.evenRow : styles.oddRow}
                  onClick={() => onStudentSelect(student)}
                >
                  <td className={styles.nameCell}>{student.nombre}</td>
                  <td>{student.matricula}</td>
                  <td>{student.campus}</td>
                  <td>{student.programa}</td>
                  <td>{student.cicloEscolar}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '24px 12px' }} className={styles.noResults}>
                  No se encontraron estudiantes con los criterios de búsqueda.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {students.length > 0 && (
        <div className={paginationStyles.paginationControls}>
          <span className={paginationStyles.paginationInfo}>
            Mostrando {startIndex + 1}-{Math.min(startIndex + PAGE_SIZE, students.length)} de {students.length}
          </span>
          <button
            type="button"
            className={paginationStyles.paginationButton}
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          >
            Anterior
          </button>
          <span className={paginationStyles.paginationInfo}>
            Página {currentPage} de {totalPages}
          </span>
          <button
            type="button"
            className={paginationStyles.paginationButton}
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
          >
            Siguiente
          </button>
        </div>
      )}
    </div>
  );
}

export default StudentResults;
